import { RefObject, useEffect, useState } from "react";

/**
 * 타겟 element 가 viewport 위로 완전히 스크롤되어 빠져나갔는지 추적.
 * Hero 같은 첫 섹션을 지났는지 판정해서 sticky CTA 표시할 때 사용.
 */
export function useScrollPast(
  targetRef: RefObject<HTMLElement | null>,
): boolean {
  const [past, setPast] = useState(false);

  useEffect(() => {
    const el = targetRef.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        // 뷰포트 위로 빠져나갔으면 past=true (boundingRect.top < 0)
        // 뷰포트 안에 있거나 아래에 있으면 past=false
        setPast(!entry.isIntersecting && entry.boundingClientRect.top < 0);
      },
      { threshold: 0 },
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, [targetRef]);

  return past;
}
